module.exports = __webpack_public_path__ + "img/header-phone.4db3fb2d.jpg";